import React, { Component } from 'react';
import lottie from 'lottie-web';

import AnimeLogo from '../../assets/logo_animation.json';
import {
  AnimContainer,
} from './LoadingAnim.styles';

export default class LoadingAnim extends Component {
  constructor(props) {
    super(props);
    this.loadingAnimRef = React.createRef();
  }

  componentDidMount() {
    lottie.loadAnimation({
      container: this.loadingAnimRef.current,
      renderer: `svg`,
      loop: true,
      autoplay: true,
      animationData: AnimeLogo,
    });
  }

  render() {
    return (
      <AnimContainer ref={this.loadingAnimRef} />
    );
  }
}
